const getTextsFile = (fileList) => {
  return fileList.filter((file) => {
    return file.name.indexOf("texts") + 1;
  })[0] ?? null;
};

const getLinkFile = (fileList) => {
  return fileList.filter((file) => {
    return file.name.indexOf("link") + 1;
  })[0] ?? null;
};

const readTextFileContent = (textFile) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();

    fileReader.addEventListener("load", () => {
      resolve(fileReader.result);
    }, false);

    fileReader.addEventListener("error", (error) => {
      reject(error);
    }, false);

    fileReader.readAsText(textFile);
  });
};

export const getCreativeFiles = (fileList) => {
  return fileList
    .filter((file) => {
      const isAllowedImageFile = file.type.indexOf("jpeg") + 1
      || file.type.indexOf("gif") + 1;
      const isAllowedVideoFile = file.type.indexOf("mp4") + 1;

      return isAllowedImageFile || isAllowedVideoFile;
    })
    .sort((fileA, fileB) => {
      const fileAName = fileA.name.split(".")[0];
      const fileBName = fileB.name.split(".")[0];

      return Number(fileAName) - Number(fileBName);
    });
};

export const getCreativeTexts = async (fileList) => {
  const textsFile = getTextsFile(fileList);
  let textsFileContent = null;

  await readTextFileContent(textsFile).then((result) => {
    textsFileContent = result;
  });

  const hasCarriageReturnSymbol = textsFileContent.indexOf("\r") + 1;
  let textsArray = [];

  if (hasCarriageReturnSymbol) {
    textsArray = textsFileContent.split("\r\n");
  } else {
    textsArray = textsFileContent.split("\n");
  }

  const textsObject = {};

  textsArray.forEach((text) => {
    const dividerIndex = text.indexOf(".");
    const textKey = text.slice(0, dividerIndex);
    const textValue = text.slice(dividerIndex + 1, text.length).trim();

    if (textKey && textValue) {
      textsObject[textKey] = textValue;
    }
  });

  return textsObject;
};

export const getCreativeUrl = async (fileList) => {
  const linkFile = getLinkFile(fileList);
  let url = null;

  await readTextFileContent(linkFile).then((result) => {
    url = result.trim();
  });

  return url;
};
